var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7.66686L28.5883 3.87353C28.8424 3.74659 29.1246 3.68666 29.4083 3.69944C29.692 3.71222 29.9677 3.79728 30.2093 3.94654C30.4509 4.09581 30.6504 4.30432 30.7888 4.55232C30.9271 4.80031 30.9998 5.07955 31 5.36353V16.6369C30.9998 16.9208 30.9271 17.2001 30.7888 17.4481C30.6504 17.6961 30.4509 17.9046 30.2093 18.0539C29.9677 18.2031 29.692 18.2882 29.4083 18.301C29.1246 18.3137 28.8424 18.2538 28.5883 18.1269L21 14.3335V7.66686Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4.33333C1 3.44928 1.35119 2.60143 1.97631 1.97631C2.60143 1.35119 3.44928 1 4.33333 1H17.6667C18.5507 1 19.3986 1.35119 20.0237 1.97631C20.6488 2.60143 21 3.44928 21 4.33333V17.6667C21 18.5507 20.6488 19.3986 20.0237 20.0237C19.3986 20.6488 18.5507 21 17.6667 21H4.33333C3.44928 21 2.60143 20.6488 1.97631 20.0237C1.35119 19.3986 1 18.5507 1 17.6667V4.33333Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLive);
export default __webpack_public_path__ + "static/media/new-live.b45491ad1a58737253f61a5404d4d444.svg";
export { ForwardRef as ReactComponent };